import { atom } from "jotai";
import { selectAtom } from "jotai/utils";
import { cloneDeep } from "lodash-es";
import {
  HCOST_INBOUND_DATA,
  HCOST_MODEL_DATA,
  HCOST_RESULT_DATA,
  HCOST_RESULT_DATA_V2,
} from "@constants/hcost/hcost-data";
import ArrayStore from "devextreme/data/array_store";
import { atomWithImmer } from "jotai-immer";
import { checkVersion, QA_FLAG_STAGING } from "@vhows/util";
import { CounselModelData } from "@constants/inbound";

export const hcostModelAtom = atomWithImmer(cloneDeep(HCOST_MODEL_DATA));
export const hcostFactorListAtom = atomWithImmer([]);
export const factorListValueAtom = atom([]);
export const hcostResultAtom = atomWithImmer<HcostResult | HcostResultV2>(
  cloneDeep(checkVersion("0.0.2", QA_FLAG_STAGING) ? HCOST_RESULT_DATA_V2 : HCOST_RESULT_DATA),
);
export const modelFactorAtom = selectAtom(hcostModelAtom, v => v.hcostFactors);
export const modelFactorDataSourceAtom = atom(get => {
  return new ArrayStore({
    key: "id",
    data: get(modelFactorAtom),
  });
});
export const resultFactorAtom = selectAtom(hcostResultAtom, v => v.hcostFactors);
export const resultFactorDataSourceAtom = atom(get => {
  return new ArrayStore({
    key: "id",
    data: get(resultFactorAtom),
  });
});
export const factorValueAtom = atomWithImmer([]);
export const hcostInboundAtom = atomWithImmer(cloneDeep(HCOST_INBOUND_DATA));
export const hcostInboundDesignsValueAtom = atom([]);
// 견적상담 요소 리스트
export const counselItemListAtom = atom([]);
// 견적상담 모델
export const counselModelAtom = atomWithImmer(cloneDeep(CounselModelData));
export const hcostInboundBrokerageValueAtom = atom([]);
